import { Controller } from "@hotwired/stimulus"

// Use this controller to automatically check and uncheck checkboxes when clicking the designated check all checkbox
// OR when clicking any of the checkboxes in the group (when all are checked the check all box is automatically turned
// on and when any is unchecked the check all box will be unchecked).
//
// When a checkbox is checked or unchecked the controller will dispatch a change event with the total number of
// checkboxes and the number of checked checkboxes. You can use this controller with other controllers by using
// that event in data-action attributes: data-action="check-all:change->controller#action".
export default class extends Controller {
  static get targets() {
    return ["all", "check"]
  }

  static get values() {
    return {
      dispatchEvent: { type: Boolean, default: true },
      dispatchEventPerCheckbox: { type: Boolean, default: true }
    }
  }

  connect() {
    this.allTarget.addEventListener("change", this.toggleCheckAll.bind(this))
    this.checkTargets.forEach(checkboxTarget => {
      checkboxTarget.addEventListener("change", this.toggleCheckbox.bind(this))
    })

    this.allTarget.indeterminate = false
    this.allTarget.checked = false

    if (this.checkTargets.every(checkboxTarget => { return checkboxTarget.checked })) {
      this.allTarget.checked = true
    } else if (this.checkTargets.some(checkboxTarget => { return checkboxTarget.checked })) {
      this.allTarget.indeterminate = true
    }
  }

  clear() {
    this.allTarget.checked = false
    this.allTarget.indeterminate = false
    this.checkTargets.forEach(checkboxTarget => {
      checkboxTarget.checked = false
    })
  }

  toggleCheckAll(e) {
    let checkState = (typeof e.params !== "undefined") ? e.params.state : this.allTarget.checked

    this.checkTargets.forEach(checkboxTarget => {
      // Only check visible element
      if (checkboxTarget.offsetWidth > 0 || checkboxTarget.offsetHeight > 0) {
        checkboxTarget.checked = checkState

        if (this.dispatchEventPerCheckbox) {
          checkboxTarget.dispatchEvent(new Event("change"))
        }
      }
    })

    this.dispatchChangeEvent()
  }

  toggleCheckbox(event) {
    if (event.target.checked) {
      if (this.checkTargets.every(checkboxTarget => { return checkboxTarget.checked })) {
        this.allTarget.checked = true
        this.allTarget.indeterminate = false
      } else {
        this.allTarget.indeterminate = true
      }
    } else {
      this.allTarget.checked = false
      this.allTarget.indeterminate = this.checkTargets.some(checkboxTarget => { return checkboxTarget.checked })
    }

    this.dispatchChangeEvent()
  }

  dispatchChangeEvent() {
    if (this.dispatchEventValue) {
      let checkedTargets = this.checkTargets.filter(checkboxTarget => { return checkboxTarget.checked })
      this.dispatch("change", { detail: { total: this.checkTargets.length,
                                          checked: checkedTargets.length,
                                          dataSets: checkedTargets.map(checkedTarget => checkedTarget.dataset) }})
    }
  }
}
